module.exports = __webpack_public_path__ + "img/sidebar-1.cf182f51.jpg";